// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-elevation-z8 {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.file-container {
  border: 2px solid #0B2D71;
  width: 100%;
  margin: 20px auto;
  background-color: #fff;
  
}
 .select-text {
    color: white;
    padding: 10px;
    background-color: rgb(102, 153, 204);
    text-align: left;
    border-radius: 0px 0px 0 0;
    font-family: "GothamBold",Arial,sans-serif;
}
/* .container1 label {
    
    padding: 0.5%;
  } */

.small-textbox {
    flex: 1;
}

  .small-select {
    width: 180px; 
  }
.small-select-btn {
width: 70px; 
}
.field-buttons {
position: relative;
right: 0;
top: 0; 
}
.selected-fields {
    position: relative;
    right: 0;
    top: 0; 
}
.perview-pagesetup{
    position: relative;
    right: 0;
    top: 0; 
}
 .table-wrapper {
   
    overflow-y: auto;
  }
  
  .material-table-scrollbar {
    display: block;
  }
   
  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
  }
  .button-container1{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    height: 20vh;
  }
  .span-lablerightside {
    margin-left: 50px;
}
.move-right {
  margin-left: 20px;
}
.aligned-label {
  margin-right: 40px; 
}

.center-content {
  margin: auto !important;
  text-align: center;
}
.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
th {
  background-color:#0b2d71;
  font-weight: bold;
}
table th {
  background-color: #0b2d71 !important;
  color: white;
  font-weight: bold;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
table th {
background-color: #0b2d71 !important;
color: white;
font-weight: bold;
}
th, td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

th {
  background-color:#0b2d71;
  font-weight: bold;
}
.title {
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  font-size: 100%;
}
.title h3 {
color: white !important;
text-align: left;
margin-top: auto;
margin-bottom: auto;
}
app-lookup {
  display: block;
  width: 100%;
}

.bordered-container {
  border: 1px solid #d3d3d3; 
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
}
.error-message {
  color: red;
  font-weight: bold;
}

 
`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/searchredelegation/searchredelegation.component.css"],"names":[],"mappings":"AAAA;EACE,2HAA2H;AAC7H;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;;AAExB;CACC;IACG,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,0BAA0B;IAC1B,0CAA0C;AAC9C;AACA;;;KAGK;;AAEL;IACI,OAAO;AACX;;EAEE;IACE,YAAY;EACd;AACF;AACA,WAAW;AACX;AACA;AACA,kBAAkB;AAClB,QAAQ;AACR,MAAM;AACN;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;CACC;;IAEG,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;EACA;IACE,iBAAiB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;AACA,oCAAoC;AACpC,YAAY;AACZ,iBAAiB;AACjB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;AACA,uBAAuB;AACvB,gBAAgB;AAChB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB","sourcesContent":[".mat-elevation-z8 {\n  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.file-container {\n  border: 2px solid #0B2D71;\n  width: 100%;\n  margin: 20px auto;\n  background-color: #fff;\n  \n}\n .select-text {\n    color: white;\n    padding: 10px;\n    background-color: rgb(102, 153, 204);\n    text-align: left;\n    border-radius: 0px 0px 0 0;\n    font-family: \"GothamBold\",Arial,sans-serif;\n}\n/* .container1 label {\n    \n    padding: 0.5%;\n  } */\n\n.small-textbox {\n    flex: 1;\n}\n\n  .small-select {\n    width: 180px; \n  }\n.small-select-btn {\nwidth: 70px; \n}\n.field-buttons {\nposition: relative;\nright: 0;\ntop: 0; \n}\n.selected-fields {\n    position: relative;\n    right: 0;\n    top: 0; \n}\n.perview-pagesetup{\n    position: relative;\n    right: 0;\n    top: 0; \n}\n .table-wrapper {\n   \n    overflow-y: auto;\n  }\n  \n  .material-table-scrollbar {\n    display: block;\n  }\n   \n  .button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 60px;\n  }\n  .button-container1{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 60px;\n    height: 20vh;\n  }\n  .span-lablerightside {\n    margin-left: 50px;\n}\n.move-right {\n  margin-left: 20px;\n}\n.aligned-label {\n  margin-right: 40px; \n}\n\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\nth {\n  background-color:#0b2d71;\n  font-weight: bold;\n}\ntable th {\n  background-color: #0b2d71 !important;\n  color: white;\n  font-weight: bold;\n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\ntable th {\nbackground-color: #0b2d71 !important;\ncolor: white;\nfont-weight: bold;\n}\nth, td {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\nth {\n  background-color:#0b2d71;\n  font-weight: bold;\n}\n.title {\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: center;\n  font-size: 100%;\n}\n.title h3 {\ncolor: white !important;\ntext-align: left;\nmargin-top: auto;\nmargin-bottom: auto;\n}\napp-lookup {\n  display: block;\n  width: 100%;\n}\n\n.bordered-container {\n  border: 1px solid #d3d3d3; \n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n}\n.error-message {\n  color: red;\n  font-weight: bold;\n}\n\n \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
